enum NotificationEmailVerificationType {
    MANUAL = 'manual',
    VERIFICATION_CODE = 'verification_code',
}

export default NotificationEmailVerificationType;
